import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { POSITION_BOTTOM, POSITION_RIGHT } from '../../../helpers/getCssPosition';
import UiKitDropdown from '../../../core/components/Dropdown';
import { OptionsIcon, OptionsButton, Option, Container } from './styles';
const OptionMenu = ({ className, 'data-qa-anchor': dataQaAnchor = '', icon, options, position = POSITION_BOTTOM, align = POSITION_RIGHT, pullRight = true, }) => {
    const [isOpen, setIsOpen] = useState(false);
    const toggle = () => setIsOpen(!isOpen);
    const close = () => setIsOpen(false);
    const attachCanceling = (fn) => () => {
        close();
        fn && fn();
    };
    const triggerRenderer = (props) => {
        return React.createElement(OptionsButton, Object.assign({}, props), icon || React.createElement(OptionsIcon, null));
    };
    return (options.length > 0 && (React.createElement(Container, { className: className, pullRight: pullRight },
        React.createElement(UiKitDropdown, { "data-qa-anchor": dataQaAnchor, isOpen: isOpen, renderTrigger: (props) => triggerRenderer(Object.assign(Object.assign({}, props), { onClick: toggle, className, icon })), position: position, align: align, handleClose: () => setIsOpen(false) }, options.map(({ name, action, className: optionClassName }) => (React.createElement(Option, { key: name, "data-qa-anchor": `${dataQaAnchor}-${name}`, className: optionClassName, onClick: attachCanceling(action) },
            React.createElement(FormattedMessage, { id: name }))))))));
};
export default OptionMenu;
//# sourceMappingURL=index.js.map